import { getDefaultConfig } from './getDefaultConfig';
import { getCrmPatientDemographicData } from '../utils';

/**
 * Function that returns the Crm-specific config for Direct Book.
 * @param {Object} props - The config properties
 * @param {string} props.customerCode - represents a customer
 * @param {Object} props.location - the react-router location object
 * @param {Object} props.tokens - tokens from pmc redux store
 * @param {Object} props.searchSDK
 * @param {Object} props.crmConnector - interface for crm-connector widget
 * @returns the Crm-specific config
 */
export const getCrmConfig = ({
  customerCode,
  location,
  tokens,
  config,
  searchSDK,
  crmConnector
}) => {
  const baseConfig = getDefaultConfig({
    customerCode,
    location,
    tokens,
    config,
    searchSDK
  });

  const { state } = crmConnector;

  const patient = state?.context?.patient;

  if (!patient) {
    throw new Error('Could not find a patient within the CRM context');
  }

  return {
    ...baseConfig,
    ehr: {
      pid: patient.mrn,
      pid_type: 'patient_id'
    },
    services: {
      ...baseConfig.services,
      getEhrPatientDemographics: () => getCrmPatientDemographicData(patient)
    }
  };
};
